// Translations
import actions from './actions'
import components from './components'
import format from './format'
import generic from './generic'
import notices from './notices'
import notifications from './notifications'
import pages from './pages'
import status from './status'
import terminology from './terminology'
import time from './time'

// Translation: English
export default Object.freeze({
	_: {
		code: 'en',
		name: 'English'
	},
	actions,
	components,
	format,
	generic,
	notices,
	notifications,
	pages,
	status,
	terminology,
	time
})
